<script lang="ts" setup async>
import {ReccoRecommendationTypeDTO} from '@/ts/types/dto/recco/recommendation.dto';
import type {ReccoAudioDTO} from '@/ts/types/dto/recco/audio.dto';
import ReccoContentCard from '@/vue/molecules/recco/recommendation-cards/recommendation-card-content.vue';

const props = defineProps<{
  audioRecommendation: ReccoAudioDTO;
}>();

const {audioRecommendation} = props;
</script>

<template>
  <div class="audio-container">
    <div class="audio-player">
      <recco-content-card :recommendation="{...audioRecommendation, type: ReccoRecommendationTypeDTO.Audio}"/>
    </div>

    <div v-safe-html="audioRecommendation.description" class="audio-description"/>
  </div>
</template>

<style lang="scss" scoped>
.audio-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Spacing-spacing-5);
  // Fill the page width instead of shrinking to the media's intrinsic size under a
  // centering parent (e.g. recommendation-page's align-items: center) (IPD-2893).
  width: 100%;
}

.audio-player {
  // Fill the container width like the article/video cards; without this the flex
  // parent (align-items: flex-start) shrinks the card to its content (IPD-2893).
  width: 100%;
  border-radius: var(--card-border-radius);
  overflow: hidden;
}

.audio-description {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--Spacing-spacing-7) var(--Spacing-spacing-8) var(--Spacing-spacing-8) var(--Spacing-spacing-6);
  gap: var(--Spacing-spacing-4);
  flex-shrink: 0;

  @include font-body;

  @include screen-2xl {
    @include column-width(6, 10);
  }

  @include screen-xl {
    @include column-width(9, 10);
  }

  @include screen-lg {
    @include column-width(8, 10);
  }

  @include screen-md {
    @include column-width(8, 10);
  }
}
</style>
